import React from 'react'

import CTA from '@f/elements/CTA'

const ImageHeadingDescription = ({
  tag = null,
  heading = null,
  description = null,
  cta_label = null,
  href = null,
  imageUri = null
}) => {
  const truncateStr = (str = '', maxlength = 0) => {
    return str.length > maxlength ? str.slice(0, maxlength - 1) + '…' : str
  }

  return (
    <>
      <img
        className='Card-image'
        src={imageUri}
        alt=''
        height='240'
        width='320'
      />
      <span className='[ f-d-bl f-p-a-020 f-c-bo-neu025 ] Card-info'>
        {heading ? (
          <span
            className='[ f-d-bl f-t-tbody f-c-fo-pri f-t-ellip {% if description %}f-m-b-010{% else %}f-t-centre{% endif %} ]'
            title='{{heading}}'>
            {heading}
          </span>
        ) : null}

        {description ? (
          <span
            className='[ f-d-bl f-t-mini f-c-fo-pri f-overflow ]'
            title={truncateStr(description, 84)}>
            {truncateStr(description, 84)}
          </span>
        ) : null}

        {cta_label ? (
          tag === 'a' ? (
            <span className='[ f-t-mini f-t-bold f-c-fo-ter ]'>
              {cta_label}
            </span>
          ) : (
            <CTA
              type='text-primary'
              tag='a'
              href={href}
              icon='right-link-16px'
              iconClassName='[ f-icon-020 f-icon-t-body f-c-st-inherit f-m-t-030 f-m-r-010 ]'
              className='Card-link'>
              {cta_label}
            </CTA>
          )
        ) : null}
      </span>
    </>
  )
}

export default ImageHeadingDescription
